import { BaseService, Service } from "/@/cool";
@Service("couponSettleLog")
class CouponSettleLog extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
		this.permission["export"] = prefix + "export";
		this.permission["settleCouponList"] = prefix + "settleCouponList";
	}

	SettleCouponList(params: any) {
		return this.request({
			url: "/settleCouponList",
			method: "POST",
			data: {
				...params
			}
		});
	}
}

export default CouponSettleLog;
